export enum UserIdentifierType {
  Username = 'username',
  EmailAddress = 'email_address',
  PhoneNumber = 'phone_number',
  Google = 'google',
  Apple = 'apple',
  Github = 'github',
}
